import { constants } from '@common/services'
export default class Translations {
  constructor(api) {
    this.api = api
  }

  getTranslations = async opts => {
    try {
      const { component } = opts.params
      const url = `${
        constants.CDN_TRANSLATIONS_URL
      }/${component}.json?timestamp=${new Date().getTime()}`
      const res = await this.api.get(url)
      return res
    } catch (err) {
      err.isTranslation = true
      throw err
    }
  }
}
